import Collapse from './_collapse';
import CollapseItem from './collapse-item';

Collapse.CollapseItem = CollapseItem;

export default Collapse;
